function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { useState, useEffect, useCallback } from "react";
import isEqual from "lodash/isEqual";
import merge from "lodash/merge";
import { useFormContext } from "../../FormContext/FormContext";
export function useField(fieldOptions) {
    var name = fieldOptions.name, validate = fieldOptions.validate, dependenciesProp = fieldOptions.dependencies, readOnlyProp = fieldOptions.readOnly, required = fieldOptions.required, onBlur = fieldOptions.onBlur, onUpdate = fieldOptions.onUpdate, onUpdateTransform = fieldOptions.onUpdateTransform;
    var formContext = useFormContext();
    var getValue = formContext.getValue, setValue = formContext.setValue, setValidator = formContext.setValidator, removeValidator = formContext.removeValidator, subscribe = formContext.subscribe, unsubscribe = formContext.unsubscribe, getError = formContext.getError, runValidation = formContext.runValidation, readOnly = formContext.readOnly, removeData = formContext.removeData;
    var setFieldState = useFieldState();
    var dependencies = useStableDependencies(dependenciesProp);
    useEffect(function() {
        setValidator(name, validate, dependencies);
        return function() {
            removeValidator(name);
        };
    }, [
        name,
        validate,
        dependencies,
        setValidator,
        removeValidator
    ]);
    useEffect(function() {
        subscribe(name, setFieldState, dependencies);
        return function() {
            return unsubscribe(name, dependencies);
        };
    }, [
        name,
        dependencies
    ]);
    var getFieldValue = useCallback(function() {
        return getValue(name);
    }, [
        getValue,
        name
    ]);
    var getDependencyValues = useCallback(function() {
        return Array.isArray(dependencies) ? dependencies.reduce(function(accumulator, dependencyFieldName) {
            return _objectSpread({}, accumulator, _defineProperty({}, dependencyFieldName, getValue(dependencyFieldName)));
        }, {}) : {};
    }, [
        dependencies,
        getValue
    ]);
    var getFieldErrors = useCallback(function() {
        return getError(name);
    }, [
        getError,
        name
    ]);
    var setFieldValue = useCallback(function(value) {
        return setValue(name, value);
    }, [
        name,
        setValue
    ]);
    var removeFieldData = useCallback(function() {
        return removeData(name);
    }, [
        name,
        removeData
    ]);
    var validateField = useCallback(function() {
        return runValidation(name);
    }, [
        name,
        runValidation
    ]);
    var handleBlur = useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        validateField();
        if (typeof onBlur === 'function') {
            return onBlur.apply(void 0, _toConsumableArray(args));
        }
    }, [
        onBlur,
        validateField
    ]);
    var handleUpdate = useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (typeof onUpdateTransform === 'function') {
            setFieldValue(onUpdateTransform.apply(void 0, _toConsumableArray(args)));
        } else {
            setFieldValue(args[0]);
        }
        if (typeof onUpdate === 'function') {
            return onUpdate.apply(void 0, _toConsumableArray(args));
        }
    }, [
        onUpdate,
        onUpdateTransform,
        setFieldValue
    ]);
    var readOnlyField = readOnlyProp !== null && readOnlyProp !== void 0 ? readOnlyProp : readOnly;
    var showRequired = !readOnlyField && required;
    var field = {
        get fieldValue () {
            return getFieldValue();
        },
        getFieldValue: getFieldValue,
        get dependencyValues () {
            return getDependencyValues();
        },
        getDependencyValues: getDependencyValues,
        get fieldErrors () {
            return getFieldErrors();
        },
        getFieldErrors: getFieldErrors,
        readOnlyField: readOnlyField,
        showRequired: showRequired,
        handleBlur: handleBlur,
        handleUpdate: handleUpdate,
        setFieldValue: setFieldValue,
        removeFieldData: removeFieldData,
        validateField: validateField,
        formContext: formContext
    };
    return field;
}
export default useField;
function useFieldState() {
    var ref = _slicedToArray(useState(), 2), fieldState = ref[0], setInternalFieldState = ref[1];
    return useCallback(function(type, fieldName, value) {
        setInternalFieldState(merge({}, fieldState, _defineProperty({}, "".concat(type, "_").concat(fieldName), value)));
    }, [
        fieldState
    ]);
}
function useStableDependencies(dependenciesProp) {
    var ref = _slicedToArray(useState(dependenciesProp), 2), dependencies = ref[0], setDependencies = ref[1];
    useEffect(function() {
        if (!isEqual(dependenciesProp, dependencies)) {
            setDependencies(dependenciesProp);
        }
    }, [
        dependencies,
        dependenciesProp
    ]);
    return dependencies;
}
